





































































































































































import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import Footer from "@/components/Footer.vue";
import StripeApi from "@/services/StripeApi";
import CustomerForm from "@/components/forms/CustomerForm.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";
import AuthModule from "@/store/auth";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import { CreateSubscription, UpdateSubscription } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    CustomerForm,
    CTooltip,
    Footer,
  },
})
export default class URegisterPayment extends CheckUserLogin {
  // プラン再開のダイアログ
  private isRestartDialog = false;

  // 顧客情報が登録されたときにつくIDの初期値
  private cusId = "";

  // 決済顧客情報
  private customer = {};

  // 決済カード情報
  private card = {};

  // サブスクリプションキャンセル
  private isSubscriptionCancel = false;

  // 入力フォーム初期値
  private cancelForm: UpdateSubscription = { subId: "", endOfPeriodCancel: false };

  // plan入力フォーム初期値
  private restartForm: CreateSubscription = {
    cusId: "",
    planId: "",
    userUuid: "",
  };

  private couponName = "";

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private async mounted() {
    await this.fetch();
  }

  // 登録アカウントのプレミアム会員に関するデータの取得
  @Watch("me")
  private async fetch() {
    if (this.me?.cusId && this.me.paidFlag) {
      this.cusId = this.me.cusId;

      const subscriptionRes = await StripeApi.instance.getSubscriptionByCusId(this.cusId);
      const subscription = subscriptionRes.data.data[0];

      if (subscription.discount && subscription.discount.coupon) {
        this.couponName = subscription.discount.coupon.name;
      }

      this.cancelForm.subId = subscription.id;
      this.isSubscriptionCancel = subscription.cancel_at_period_end;
    }
    if (this.me?.cusId) {
      const customerRes = await StripeApi.instance.getCustomerByCusId(this.cusId);
      this.customer = customerRes.data;

      const cardRes = await StripeApi.instance.getPaymentMethodsByCusId(this.cusId);

      const { card } = cardRes.data.data[0];
      this.card = card;
    }
  }

  private async submit() {
    try {
      const getSubscription = await StripeApi.instance.getSubscriptionByCusId(this.cusId);
      // getSubscription.data.dataのlengthが0よりも大きい場合はunCancelを実行
      if (getSubscription.data.data.length > 0) {
        await this.unCancel();
      } else {
        await this.restart();
      }
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 解約をキャンセル
  private async unCancel() {
    try {
      // サブスクリプションを再開
      const updateSubscription = await StripeApi.instance.updateSubscription(this.cancelForm);
      if (!updateSubscription.data.cancel_at_period_end) {
        this.isSubscriptionCancel = updateSubscription.data.cancel_at_period_end;
        this.isRestartDialog = false;
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // プレミア登録を再開
  private async restart() {
    try {
      const plansRes = await StripeApi.instance.allGetPlan();
      this.restartForm.planId = plansRes.data.data[0].id;

      this.restartForm.cusId = this.cusId;
      if (this.me) {
        this.restartForm.userUuid = this.me?.uuid;
      }

      // サブスクリプションを登録
      await StripeApi.instance.createSubscription(this.restartForm);
      await this.fetch();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
